import React from 'react';

const Vectors = () => {
    return (
        <div>Vectors Component</div>
    );
}

export default Vectors;
